import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone:true,
  imports:[CommonModule, FormsModule, RouterLink, RouterLinkActive, MatAutocompleteModule,
  MatInputModule],
  template:
  `      
    <!-- ACCOUNT TABS -->
    <div class="actions">
      <div class="action"
            *ngFor="let a of topOptions"
            [class.active]="selectedTopOption===a"
           (click)="selectTopOption(a)">
        <div class="circle">
          <img [src]="a.icon" class="action-img">
        </div>
        <div>{{a.name}}</div>
      </div>
    </div>

    <div class="profile-card">
      <!-- INFO -->
      <div *ngIf="selectedTopOption.name === 'Info'">
        <div class="edit-only-top-bar" *ngIf="ShowEditButton">
          <div class="top-actions">
            <button class="edit-icon-btn"
                    (click)="editUserDetails()">
              ✎
            </button>
          </div>
        </div>
        <div class="section-title">{{accountInfoHeading}}</div>
        <!-- METER NUMBER -->
        <div class="field">
          <label class="field-label">WhatsApp Number</label>
          <input class="input" value="{{userWhatsAppNumber}}" readonly>
        </div>
        <!-- NAME -->
        <div class="field">
          <label class="field-label">Name</label>
          <input class="input" value="{{userName}}" readonly>
        </div>
        <!-- SURNAME -->
        <div class="field">
          <label class="field-label">Surname</label>
          <input class="input" value="{{userSurname}}" readonly>
        </div>
        <!-- EMAIL -->
        <div class="field">
          <label class="field-label">Email Address</label>
          <input type="text" class="input" 
            [(ngModel)]="userEmailAddress" 
            [readonly]="isUserEmailAddressReadonly"
            (ngModelChange)="userEmailValidationMessage = ''">
          <div class="validation-message" *ngIf="userEmailValidationMessage">
            {{userEmailValidationMessage}}
          </div>
        </div>

        <!-- BUTTONS -->
        <div class="btns" *ngIf="ShowEditUserDetailsActionButtons">
          <button class="cancel"
                  (click)="CancelEditUserInfo()">
            Cancel
          </button>
          <button class="primary"
                  (click)="updateUserInfo()">
            Save
          </button>
        </div>       
      </div>
    
      <!-- PAYSHAP ACCOUNTS -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && !selectedPayshapAccount && !showAddNewPayshapAccount">
        <!-- ADD PAYSHAP ACCOUNT BUTTON -->
        <div class="edit-only-top-bar" >
          <div class="top-actions">
            <button class="icon-btn "
                    (click)="onAddNewPayshapAccount();">
              <span class="icon-text">+</span>
            </button>
          </div>
        </div>
        <!-- HEADING -->
        <div class="section-title">
          Bank Accounts
        </div>
        <!-- ACTIVE/INACTIVE -->
        <div class="line-segment">
          <div [class.selected]="showActivePayshapAccounts"
              (click)="changePayshapAcountsList(true)">
            Active accounts
          </div>
          <div [class.selected]="!showActivePayshapAccounts"
              (click)="changePayshapAcountsList(false)">
            Inactive accounts
          </div>
        </div>
        <!-- ACCOUNT SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search account"
                [(ngModel)]="searchInput">
          <span class="search-icon">⌕</span>
        </div>
        <!-- PAYSHAP ACCOUNTS LIST-->
        <div class="profile-scroll">
          <div class="table-list">
            <div class="row" *ngFor="let c of filteredPayshapAccounts()" 
              (click)="openPayshapAccount(c)">
              <div class="contact-details">
                <strong class="tx-title">{{ c.bankName }}</strong>
                <small class="tx-number">{{ c.accountNumber }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PAYSHAP ACCOUNT DETAILS -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && selectedPayshapAccount">
        <div class="top-bar" *ngIf="showPayshapAccountInfoOptions">
          <div class="back-btn"
              (click)="selectedPayshapAccount = null">
            ←
          </div>
          <div class="top-actions">
            <button class="icon-btn "
                      (click)="updatePayshapAccountStatus(selectedPayshapAccount)">
              <span class="material-icons status-icon" 
                [class.active-icon]="selectedPayshapAccount.isActive" 
                [class.inactive-icon]="!selectedPayshapAccount.isActive"> 
                {{ selectedPayshapAccount.isActive ? 'toggle_on' : 'toggle_off' }}
              </span>
            </button>
          </div>
        </div>
        <div class="section-title">
          Bank Account Info
        </div>
        <div>
          <div class="field">
            <!-- BANK -->
            <div>
              <label class="field-label">Bank</label>
              <input class="input" placeholder="{{selectedPayshapAccount.bankName}}" readonly>
            </div>
            <!-- BRANCH CODE -->
            <div>
              <label class="field-label">Branch Code</label>
              <input class="input" placeholder="{{selectedPayshapAccount.bankBranchCode}}" readonly>
            </div>
            <!-- ACCOUNT NUMBER -->
            <div class="field">
              <label class="field-label">Account Number</label>
              <input class="input" placeholder="{{selectedPayshapAccount.accountNumber}}" readonly>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD PAYSHAP ACCOUNT -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && !selectedPayshapAccount && showAddNewPayshapAccount">
        <div *ngIf="showSelectBank">
         <div class="back-btn" (click)="closeAddNewPayshapAccount()">
          ←
        </div>
        <div class="section-title">
          New Bank Account
        </div>
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search bank"
                  [(ngModel)]="bankSearchInput"
                   (ngModelChange)="filterBanks()">
            <span class="search-icon">⌕</span>
          </div>
          <div class="category-option" *ngFor="let p of filteredBanks"
            [class.selected]="selectedBank === p"
            (click)="selectBank(p)">
            <div class="payment-option-left">
              <span>{{ p.name }}</span>
            </div>
            <div class="tx-icon">
                <img [src]="p.logo"
                    class="tx-img">
            </div>
          </div>
        </div>
      
        <div *ngIf="showNewBankDetails">
          <div class="back-btn" (click)="returnToBanks()">
            ←
          </div>
          <div class="section-title">
            New Bank Account
          </div>
          <div class="field">
            <label class="field-label">Bank</label>
            <div class="input-with-icon">
              <input
                class="input"
                [value]="selectedBank?.name"
                readonly>
              <img
                *ngIf="selectedBank"
                [src]="selectedBank.logo"
                class="bank-logo">
            </div>
          </div>
          <div class="field">
            <label class="field-label">Branch Code</label>
            <input class="input" placeholder="{{bankBranchCode}}" readonly>
          </div>
          <!-- ACCOUNT NUMBER -->
          <div class="field">
            <label class="field-label">Account Number</label>
            <input
              class="input"
              type="text"
              inputmode="numeric"
              maxlength="20"
              placeholder="Enter account number"
              [(ngModel)]="newAccountNumber"
              (keydown)="allowOnlyNumbers($event)"
              (ngModelChange)="onAccountNumberInput($event)">
            <div class="validation-message" *ngIf="newAccountNumberValidationMessage">
              {{newAccountNumberValidationMessage}}
            </div>   
          </div>

          <!-- BUTTONS -->
          <div class="btns">
            <button class="set-authorization-btn"
              (click)="addNewPayshapAccount()"
              [disabled]="!newAccountNumber || !accountNumberValid">
              Add
          </button>
          </div>
        </div>
      </div>

      <!-- UTILITIES -->
      <div *ngIf="selectedTopOption.name === 'Utilities' && !selectedElectricityMeter && !showAddNewElectricityMeterTab">
        <!-- ADD METER BUTTON -->
        <div class="edit-only-top-bar" >
          <div class="top-actions">
            <button class="icon-btn "
                    (click)="onAddNewElectricityMeter();">
              <span class="icon-text">+</span>
            </button>
          </div>
        </div>
        <!-- HEADING -->
        <div class="section-title">
          Electricity meters
        </div>
        <!-- ACTIVE/INACTIVE -->
        <div class="line-segment">
          <div [class.selected]="showActiveElectricityMeters"
              (click)="changeElectricityMetersList(true)">
            Active meters
          </div>
          <div [class.selected]="!showActiveElectricityMeters"
              (click)="changeElectricityMetersList(false)">
            Inactive meters
          </div>
        </div>
        <!-- METER SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search meter"
                [(ngModel)]="searchInput">
          <span class="search-icon">⌕</span>
        </div>
        <!-- METERS LIST-->
        <div class="accounts-scroll">
          <div class="table-list">
            <div class="row" *ngFor="let c of filteredElectricityMeters()"
              (click)="openElectricityMeter(c)">
              <div class="contact-details">
                <strong class="tx-title">{{c.name}}</strong>
                <small class="tx-number">{{c.meterNumber}}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD METER -->
      <div  *ngIf="selectedTopOption.name === 'Utilities' && !selectedElectricityMeter && showAddNewElectricityMeterTab">
      <div class="back-btn"
              (click)="closeAddMeter()">
            ←
          </div>
        <div class="section-title">
          New electricity meter
        </div>
        <!-- NAME -->
        <div>
          <div class="field">
            <label class="field-label">Meter Name</label>
            <input class="input"
              placeholder="Enter name"
              [(ngModel)]="newMeterName"
              (ngModelChange)="meterNameValidationMessage=''">
            <div class="validation-message" *ngIf="meterNameValidationMessage">
              {{meterNameValidationMessage}}
            </div>
          </div>
          <!-- METER NUMBER -->
          <div class="field">
            <label class="field-label">Meter Number</label>
              <input
              class="input"
              type="text"
              inputmode="numeric"
              maxlength="20"
              placeholder="Enter meter number"
              [(ngModel)]="newMeterNumber"
              (keydown)="allowOnlyNumbers($event)"
              (ngModelChange)="onNewMeterNumberInput($event)">
            <div class="validation-message" *ngIf="meterNumberValidationMessage">
              {{meterNumberValidationMessage}}
            </div>
          </div>
        </div>
        <!-- BUTTONS -->
        <div class="btns">
          <button class="set-authorization-btn"
              (click)="addNewElectricityMeter()"
              [disabled]="!newMeterName || !meterNumberValid">
              Add
            </button>
        </div>
      </div>

      <!-- METER DETAILS -->
      <div *ngIf="selectedTopOption.name === 'Utilities' && selectedElectricityMeter">
        <!-- INFO ACTIONS -->
        <div class="top-bar" *ngIf="ShowElectricityMeterInfoOptions">
          <div class="back-btn"
              (click)="selectedElectricityMeter = null">
            ←
          </div>
          <div class="top-actions">
            <button class="icon-btn "
                      (click)="updateElectricityMeterStatus(selectedElectricityMeter)">
                <span class="material-icons status-icon" 
                  [class.active-icon]="selectedElectricityMeter.isActive" 
                  [class.inactive-icon]="!selectedElectricityMeter.isActive"> 
                  {{ selectedElectricityMeter.isActive ? 'toggle_on' : 'toggle_off' }}
                </span>
              </button>
            <button class="edit-icon-btn"
                    (click)="editElectricityMeter(selectedElectricityMeter)">
              ✎
            </button>
          </div>
        </div>
        <!-- ELECTRICITY METER INFO -->
        <div class="section-title">
            {{utilityInfoHeading}}
        </div>
        <div>
          <!-- NAME -->
          <div class="field">
            <label class="field-label">Name</label>
            <input class="input"
              placeholder="Enter name"
              [(ngModel)]="selectedElectricityMeter.name"
              [readonly]="isElectricityMeterReadonly"
              (ngModelChange)="meterNameValidationMessage=''">
            <div class="validation-message" *ngIf="meterNameValidationMessage">
              {{meterNameValidationMessage}}
            </div>
          </div>
          <!-- METER NUMBER -->
          <div class="field">
            <label class="field-label">Meter Number</label>
            <input class="input"
                    placeholder="Enter meter number"
                    [(ngModel)]="selectedElectricityMeter.meterNumber"
                    [readonly]="true">
          </div>
          <!-- BUTTONS -->
          <div class="btns" *ngIf="ShowEditElectricityMeterButtons">
            <button class="cancel"
                    (click)="CancelEditElectricityMeter()">
              Cancel
            </button>
            <button class="primary"
                    (click)="updateElectricityMeter()">
              Save
            </button>
          </div>
        </div>
      </div>

      <!-- SUCCESS ALERT-->
      <div class="overlay" *ngIf="showSuccessAlert">
        <div class="alert-modal">
          <div class="success-icon">
            ✓
          </div>
          <div class="alert-text">
            {{successAlertMessage}}
          </div>
        </div>
      </div>

      <!-- DELETE MODAL -->
      <div class="overlay" *ngIf="showDeactivateAlert">
        <div class="alert-modal">
          <div class="alert-text">
            {{deactivateAlertMessage}}
          </div>
          <div class="logout-actions">
            <button class="cancel-btn"
                    (click)="closeDeactivateAlert()">
              {{deactivateAlertCloseButtonText}}
            </button>
            <button class="yes-btn"
                    (click)="sendDeactivateRequest()">
              {{deactivateAlertConfirmButtonText}}
            </button>
          </div>
        </div>
      </div>
  `
})
export class ProfilePage{
  // =====================================================
  // TOP OPTIONS
  // =====================================================
  topOptions=[
  {
    name:'Utilities',
    icon:'assets/images/Topup.png'
  },
  {
    name:'Bank Accounts',
    icon:'assets/images/Withdraw.png'
  },
  {
    name:'Info',
    icon:'assets/images/History.png'
  }
  ];
  selectedTopOption=this.topOptions[2];

  selectTopOption(action: any) {
    this.selectedTopOption = action;
    this.searchInput = '';

    if (action.name === 'Utilities') {
      this.tempEmailAddress;
      this.closeAddMeter();
      this.selectedElectricityMeter = null;
      this.changeElectricityMetersList(true);
    }
    else if (action.name === 'Bank Accounts') {
       this.tempEmailAddress;
      this.closeAddNewPayshapAccount();
      this.selectedPayshapAccount = null;
      this.changePayshapAcountsList(true);
    }
    else if (action.name === 'Info') {
       this.tempEmailAddress;
      this.CancelEditUserInfo();
    }
  }
  // =====================================================
  // USER INFO
  // =====================================================
  accountInfoHeading = 'Account Info';
  userWhatsAppNumber = '0832209524';
  userName = 'Thandeka';
  userSurname = 'Madonsela';
  userEmailValidationMessage = '';
  userEmailAddress = 'madonsela@gmail.com';
  tempEmailAddress = this.userEmailAddress;

  ShowEditButton = true;
  ShowEditUserDetailsActionButtons = false;
  isUserEmailAddressReadonly = true;

  editUserDetails(){
    this.ShowEditButton = false;
    this.accountInfoHeading = 'Edit account info';
    this.isUserEmailAddressReadonly = false;
    this.ShowEditUserDetailsActionButtons = true;
  }
  CancelEditUserInfo(){
    this.ShowEditButton = true;
    this.accountInfoHeading = 'Account info';
    this.userEmailValidationMessage = '';
    this.isUserEmailAddressReadonly = true;
    this.userEmailAddress = this.tempEmailAddress;
    //this.tempEmailAddress = '';
    this.userEmailValidationMessage = '';
    this.ShowEditUserDetailsActionButtons = false;
  }
  updateUserInfo(){
    if(this.tempEmailAddress == this.userEmailAddress.trim()){
      this.userEmailValidationMessage = 'Update email address to save'
      return;
    }
    this.userEmailValidationMessage = '';
    
    //Send request

    //If successful
    this.ShowEditButton = true;
    this.isUserEmailAddressReadonly = true;
    this.ShowEditUserDetailsActionButtons = false;
    this.tempEmailAddress = this.userEmailAddress;

    this.successAlertMessage = 'User info saved successfully';
    this.showSuccessAlert= true;
    setTimeout(()=> this.showSuccessAlert = false, 1500);
  }
  // =====================================================
  // PAYSHAP
  // =====================================================
  banks = [
    {
      id:'1',
      name:'FNB',
      branchCode:'12345',
      logo:'assets/images/FNB.png'
    },
    {
      id:'2',
      name:'Capitec',
      branchCode:'12345',
      logo:'assets/images/Capitec.png'
    }
  ];
  payshapAccounts = [
    {
      bankName:'Capitec',
      bankBranchCode:'12345',
      accountNumber:'548888788',
      logo:'assets/images/Capitec.png',
      isActive: true
    },
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: true
    },
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: false
    },
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: false
    },
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: false
    }
  ];
  filteredBanks = [...this.banks];
  selectedBank:any = null;
  selectedPayshapAccount:any = null;
  bankValidationMessage = '';
  bankSearchInput = '';
  selectedBankId = '';
  newAccountNumberValidationMessage = '';
  newAccountNumber = '';

  showAddNewPayshapAccount = false;
  showActivePayshapAccounts = true;
  showPayshapAccountInfoOptions = false;

   showNewBankDetails = false;
  showSelectBank = true;
  bankBranchCode = '';
  accountNumberValid = false;
  meterNumberValid = false;
  
  onAddNewPayshapAccount() {
     this.showAddNewPayshapAccount = true;
    this.bankBranchCode = '';
    this.newAccountNumber = '';
    this.selectedBank = null;
    this.showNewBankDetails  = false;
    this.showSelectBank = true;
  }
  closeAddNewPayshapAccount() {
    this.showAddNewPayshapAccount = false;
    this.selectedBank = null;
    this.selectedBankId = '';
    this.bankSearchInput = '';
    this.newAccountNumber = '';
    this.filteredBanks = [...this.banks];
    this.bankValidationMessage = '';
    this.newAccountNumberValidationMessage = '';
    this.showPayshapAccountInfoOptions = false;
    this.bankBranchCode = '';
  }
  filterBanks(){
    this.selectedBank = null;
    const search =
      (this.bankSearchInput || '')
        .toString().toLowerCase();

    this.filteredBanks =
      this.banks.filter(x =>
        x.name.toLowerCase().includes(search)
      );
  }
  selectBank(bank:any){
    this.selectedBank = bank;
    this.showNewBankDetails = true;
    this.showSelectBank = false;
    this.bankBranchCode = bank.branchCode;
  }
  addNewPayshapAccount(){
    let hasError = false;
    this.bankValidationMessage = '';
    this.newAccountNumberValidationMessage = '';

    // ACCOUNT NUMBER
    if(!this.newAccountNumber.trim()){
      this.newAccountNumberValidationMessage = 'Account number is required';
      hasError = true;
    }
    else{
      const validation =this.validateAccountNumber();
      if(!validation.isValid){
        this.newAccountNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      

    if(hasError){
      return;
    }

    this.payshapAccounts.unshift({
      bankName: this.selectedBank.name,
      bankBranchCode: this.selectedBank.branchCode,
      accountNumber: this.newAccountNumber,
      logo: this.selectedBank.logo,
      isActive: true
    });

    this.successAlertMessage = 'Bank account added successfully';
    this.showSuccessAlert = true;
    this.showActivePayshapAccounts = true;

    setTimeout(() => {
      this.showSuccessAlert = false;
    }, 2000);

    this.closeAddNewPayshapAccount();
  }
  onAccountNumberInput(value: string) {
  this.newAccountNumber = value.replace(/\D/g, '').slice(0, 20);
   const validation =this.validateAccountNumber();
    if(this.newAccountNumber){
      if(!validation.isValid){
          this.newAccountNumberValidationMessage = validation.message;
          this.accountNumberValid = false;
        }
        else{
          this.newAccountNumberValidationMessage = '';
          this.accountNumberValid = true;
        }
    }
    else
       this.accountNumberValid = false;
  }
  validateAccountNumber(){
    let accountNumber = this.newAccountNumber.trim().replace(/\s+/g, '');
    // ONLY NUMBERS
    if(!/^\d+$/.test(accountNumber)){

      return {
        isValid:false,
        message:'Account number must contain only numbers'
      };
    }
    // LENGTH CHECK
    if(accountNumber.length < 6 ||
      accountNumber.length > 20){
      return {
        isValid:false,
        message:'Account number must be between 6 and 20 digits'
      };
    }
    // VALID
    return {
      isValid:true,
      message:''
    };
  }
  changePayshapAcountsList(mode:boolean){
    this.showActivePayshapAccounts = mode;
    this.searchInput = '';
  }
  filteredPayshapAccounts() {
    let accounts = this.payshapAccounts;
    accounts = accounts.filter(account =>
      this.showActivePayshapAccounts === true
        ? account.isActive
        : !account.isActive
    );
    const search = this.searchInput.toLowerCase();
    return accounts.filter(x =>
      x.bankName.toLowerCase().includes(search) ||
      x.accountNumber.toLowerCase().includes(search)
    );
  }
  openPayshapAccount(account:any){
    this.selectedPayshapAccount = account;
    this.showPayshapAccountInfoOptions = true;
  }
  updatePayshapAccountStatus(c:any){
    this.selectedPayshapAccount = c;
    if(c.isActive){
      this.deactivateAlertMessage = `Are you sure you want to deactivate ${c.bankName} (${c.accountNumber})`;
      this.deactivate = 'PayshapAccount'
      this.showDeactivateAlert = true;
    }
    else{
      this.selectedPayshapAccount.isActive = true;
      this.successAlertMessage = 'Bank account activated successfully';
      this.showSuccessAlert = true;
      setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    }
  }
  // =====================================================
  // UTILITIES
  // =====================================================
  electricityMeterAccounts = [
  {
    name:'Midview',
    meterNumber:'745659599',
    isActive: true
  },
  {
    name:'Home',
    meterNumber:'548888788',
    isActive: true
  },
  {
    name:'Midview',
    meterNumber:'745659599',
    isActive: false
  }
  ];
  utilityInfoHeading = 'Electricity meter info';
  selectedElectricityMeter:any = null;
  tempMeterName = '';
  meterNameValidationMessage = '';
  meterNumberValidationMessage = '';
  newMeterName = '';
  newMeterNumber = '';

  showActiveElectricityMeters = true;
  showAddNewElectricityMeterTab = false;
  ShowElectricityMeterInfoOptions = true;
  ShowEditElectricityMeterButtons = false;
  isElectricityMeterReadonly = true;


  onAddNewElectricityMeter() {
    this.showAddNewElectricityMeterTab = true;
    this.newMeterName = '';
    this.newMeterNumber = '';
  }
  onNewMeterNumberInput(){
   const validation =this.validateMeterNumber();
    if(this.newMeterNumber){
      if(!validation.isValid){
          this.meterNumberValidationMessage = validation.message;
          this.meterNumberValid = false;
        }
        else{
          this.meterNumberValidationMessage = '';
          this.meterNumberValid = true;
        }
    }
    else
      this.meterNumberValid = false;
  }
  validateMeterNumber(){
    return {
      isValid:true,
      message:'',
    };
  }
  addNewElectricityMeter(){
    let hasError = false;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';

    // NAME
    if(!this.newMeterName.trim()){
      this.meterNameValidationMessage = 'Meter name is required';
      hasError = true;
    }
    // METER NUMBER
    if(!this.newMeterNumber.trim()){
      this.meterNumberValidationMessage = 'Meter number is required';
      hasError = true;
    }
    else{
      const validation =this.validateMeterNumber();
      if(!validation.isValid){
        this.meterNumberValidationMessage = validation.message;
        hasError = true;
      }
    }

    if(hasError){
      return;
    }

    this.electricityMeterAccounts.unshift({
      name: this.newMeterName,
      meterNumber: this.newMeterNumber,
      isActive: true
    });

    //Make request

    //If successful
    this.successAlertMessage = 'Meter added successfully';
    this.showSuccessAlert = true;
    this.isElectricityMeterReadonly = true;
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    this.closeAddMeter();
  }
  closeAddMeter(){
    this.showAddNewElectricityMeterTab = false;
    this.newMeterName = '';
    this.newMeterNumber = '';
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
  }
  changeElectricityMetersList(mode:boolean){
    this.showActiveElectricityMeters = mode;
    this.searchInput = '';
  }
  filteredElectricityMeters(){
    let accounts = this.electricityMeterAccounts;
    accounts = accounts.filter(account =>
      this.showActiveElectricityMeters === true
        ? account.isActive
        : !account.isActive
    );
    const search = this.searchInput.toLowerCase();
    return accounts.filter(x =>
      x.name.toLowerCase().includes(search) ||
      x.meterNumber.toLowerCase().includes(search)
    );
  }
  openElectricityMeter(meter:any){
    this.selectedElectricityMeter = meter;
     this.utilityInfoHeading = 'Electricity meter info';
    this.ShowEditElectricityMeterButtons = false;
    this.ShowElectricityMeterInfoOptions = true;
    this.isElectricityMeterReadonly = true;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
  }
  editElectricityMeter(c:any){
    this.utilityInfoHeading = 'Edit electricity meter info';
    this.ShowEditElectricityMeterButtons = true;
    this.ShowElectricityMeterInfoOptions = false;
    this.isElectricityMeterReadonly = false;
    this.tempMeterName = this.selectedElectricityMeter.name;
    
  }
  updateElectricityMeter(){
    let hasError = false;
    let updatedMeterName = this.selectedElectricityMeter.name.trim();
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';

    // NAME
    if(!updatedMeterName){
      this.meterNameValidationMessage = 'Meter name is required';
      hasError = true;
    }
    else if(updatedMeterName == this.tempMeterName){
      this.meterNameValidationMessage = 'Update meter name to save';
      hasError = true;
    }
       
    if(hasError){
      return;
    }

    this.successAlertMessage = 'Meter updated successfully';
    this.showSuccessAlert = true;
    this.ShowEditElectricityMeterButtons = false;
    this.isElectricityMeterReadonly = true;
    this.ShowElectricityMeterInfoOptions = true;
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
  }
  CancelEditElectricityMeter(){
    this.utilityInfoHeading = 'Electricity meter info';
    this.ShowEditElectricityMeterButtons = false;
    this.ShowElectricityMeterInfoOptions = true;
    this.isElectricityMeterReadonly = true;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
    this.selectedElectricityMeter.name = this.tempMeterName;
    this.tempMeterName = '';
  }
  updateElectricityMeterStatus(c:any){
    this.selectedElectricityMeter = c;
    if(c.isActive){
      this.deactivateAlertMessage =
        `Are you sure you want to deactivate ${c.name} (${c.meterNumber})`;
      this.deactivate = 'ElectricityMeter'
      this.showDeactivateAlert = true;
    }
    else{
      this.selectedElectricityMeter.isActive = true;
      this.successAlertMessage = 'Meter activated successfully';
      this.showSuccessAlert = true;
      setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    }
  }
  // =====================================================
  // ALERTS
  // =====================================================
  showSuccessAlert=false;
  successAlertMessage = '';
  showDeactivateAlert = false;
  deactivateAlertMessage = '';
  deactivateAlertConfirmButtonText = 'Yes';
  deactivateAlertCloseButtonText = 'No';
 
  closeDeactivateAlert(){
    this.showDeactivateAlert = false;
    this.deactivate = '';
  }  
  // =====================================================
  // PAYSHAP AND UTILITIES DEACTIVATE
  // =====================================================
  deactivate = '';
  sendDeactivateRequest(){
    this.showDeactivateAlert = false;

    if(this.deactivate == 'ElectricityMeter'){
      this.successAlertMessage = 'Meter deactivated successfully';
      this.selectedElectricityMeter.isActive = false;
    }
    else if(this.deactivate == 'PayshapAccount'){
      this.successAlertMessage = 'Bank account deactivated successfully';
      this.selectedPayshapAccount.isActive = false;
    }

    this.deactivate = '';
    this.showSuccessAlert = true;
    
    setTimeout(() => {
      this.showSuccessAlert = false;
    }, 2000);
  }
   // =====================================================
  // COMMON
  // =====================================================
  searchInput = '';
 allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  returnToBanks(){
    this.selectedBank = null;
      this.bankBranchCode = '';
      this.newAccountNumber = '';
      this.showNewBankDetails  = false;
      this.showSelectBank = true;
  }
}
